import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import { CircularProgress } from "@material-ui/core";
import ScrollImage from "../../assets/images/chevron-up.svg"
import { FaPen , FaRegTrashAlt, FaPlus, FaBan, FaDownload} from "react-icons/fa";
import { highlightFirstMatch } from "../../Utils/Common";


const UserManagement = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "disabled", label: "Disabled" },
    { id: 3, value: "blocked", label: "Blocked" },
    { id: 4, value: "all", label: "All" },
  ];
  const [roleSortOptions, setRoleSortOptions] = useState([]);
  const [roleSortBy, setRoleSortBy] = useState("all");
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [sycMerchant, setSycMerchant] = useState(false);
  const [loader, setloader] = useState(false);
  const [showsScrolBtn,setShowScrolBtn]= useState(false)
  const [loading,setloading]=useState(true)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getUserData(token);
    getRole(token);
  }, []);

  useEffect(() => {
    const handleButtonVisibility=()=>{
      window.pageYOffset > 300 ? setShowScrolBtn(true) : setShowScrolBtn(false)
    }
    window.addEventListener("scroll",handleButtonVisibility)
    return(()=>{
      window.addEventListener("scroll",handleButtonVisibility)
    })

  },[]);

  const getUserData = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/users?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setloading(false)
        if (result) {
          const sortedArray = result?.sort((a, b) => {
            return a.role_name.localeCompare(b.role_name);
          });
          setData(sortedArray);
        }
      })
      .catch((error) => console.log(" errror", error));
  };

  const getRole = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/roles?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const sortOptions = result.map((item, index) => {
          return { value: item.name, label: item.name };
        });
        sortOptions.unshift({ value: "all", label: "all" });
        setRoleSortOptions(sortOptions);
      })

      .catch((error) => console.log("error", error));
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.id, token);
          setDelete(false);
          // props?.history.push(`/carousel-banners/estore`)
          // setsuccess_msg(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setSuccesAlert(false);
          setSycMerchant(false);

          window.location.reload(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
          setSycMerchant(false);
        }}
      >
        {sycMerchant
          ? "Merchant Sync Successfully"
          : "User deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/users/${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 202) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const importMerchant = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };
    await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/importusers`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          setSycMerchant(true);
          setSuccesAlert(true);
          setloader(false);
        } else {
          setErrorAlert(true);
          setloader(false);
        }
      })
      .catch((error) => console.log("error", error));
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Manage Users" />
          <Row>
            <Col style={{ position: "relative" }} md={12}></Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={12} className="d-flex justify-content-md-between">
                      <div className="button-section">
                        <Button
                          style={{ marginRight: 7 }}
                          className="btn btn-success waves-effect waves-light "
                          onClick={() => {
                            props?.history?.push("/add-user");
                          }}
                        >
                          <FaPlus size={12} /> Add User
                        </Button>
                        <Button
                          style={{
                            border: "1px solid #34C38F",
                            color: "#34C38F",
                          }}
                          className="btn btn-light waves-effect"
                          onClick={() => {
                            setloader(true);
                            importMerchant();
                          }}
                        >
                          {loader ? (
                            <CircularProgress
                              size={12}
                              value={100}
                              color={"white"}
                            />
                          ) : (
                            <FaDownload />
                          )}{" "}
                          Sync Merchants
                        </Button>
                      </div>
                      <div className="filter-section d-flex">
                        <div style={{ marginRight: "20px" }}>
                          <input
                            style={{
                              border: "2px solid rgb(238, 238, 238)",
                              width: "250px",
                              height: "35px",
                            }}
                            className="form-control"
                            placeholder="Search By Email...."
                            type="text"
                            id="page_input"
                            onChange={(e) => {
                              // handleSearch(e.target.value);
                              setSearchQuery(e.target.value.toLowerCase());
                            }}
                          />
                        </div>
                        <div className="mb-3" style={{ marginRight: 20 }}>
                          <label htmlFor="cars">Role</label>

                          <select
                            name="cars"
                            id="cars"
                            defaultValue={roleSortBy}
                            onChange={(e) => {
                              setRoleSortBy(e.target.value);
                            }}
                            style={{
                              width: 150,
                              height: 35,
                              marginLeft: 10,
                              borderRadius: "2px",
                              color: "#706b6b",
                              border: "2px solid #EEEEEE",
                            }}
                            options={roleSortOptions}
                          >
                            {roleSortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>
                                  {capitalizeFirstLetter(item?.label)}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          {/* <Label>Discount Type</Label> */}
                          <label htmlFor="cars">Status</label>

                          <select
                            name="cars"
                            defaultValue={sortOptions[0].value}
                            id="cars"
                            onChange={(e) => {
                              setSortBy(e.target.value);
                            }}
                            style={{
                              width: 150,
                              height: 35,
                              marginLeft: 10,
                              borderRadius: "2px",
                              color: "#706b6b",
                              border: "2px solid #EEEEEE",
                            }}
                            options={sortOptions}
                          >
                            {sortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {loading ? <div role="status" style={{ textAlign: "center" }}>
                        <CircularProgress
                         size={50} value={100} color={"black"}
                        />
                      </div> : <div className="table-responsive mt-3">
                    <table
                      style={{}}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr>
                          {/* <th>Page</th> */}
                          <th>First Name</th>
                          <th>Surname</th>
                          {roleSortBy == "merchant" && <th>Store Name</th>}
                          <th>Role</th>
                          <th>Email</th>
                          <th>Last Login</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 &&
                          data?.map((item, index) => {
                            if (sortBy == "enabled") {
                              if (item?.status !== "enabled") {
                                return;
                              }
                            } else if (sortBy == "disabled") {
                              if (item?.status !== "disabled") {
                                return;
                              }
                            } else if (sortBy == "blocked") {
                              if (item?.status !== "blocked") {
                                return;
                              }
                            }
                            if (
                              item?.role_name != roleSortBy &&
                              roleSortBy != "all"
                            ) {
                              return;
                            }
                            if (searchQuery) {
                              if (
                                !item?.email.toLowerCase().includes(searchQuery)
                              ) {
                                return;
                              }
                            }

                            return (
                              <tr key={index}>
                                <td>{item?.first_name}</td>
                                <td>{item?.surname}</td>
                                {roleSortBy == "merchant" && (
                                  <td>{item?.username}</td>
                                )}
                                <td>
                                  {capitalizeFirstLetter(item?.role_name)}
                                </td>
                                <td>{highlightFirstMatch(item?.email,searchQuery)}</td>
                                <td>
                                  {item?.last_login
                                    ? moment(item?.last_login).format(
                                        "DD/MM/YYYY h:mm a"
                                      )
                                    : "null"}
                                </td>
                                <td>
                                  <Button
                                    color={
                                      item.status == "enabled"
                                        ? "success"
                                        : item.status == "disabled"
                                        ? "danger"
                                        : "secondary"
                                    }
                                  >
                                    {item.status == "enabled"
                                      ? "Enabled"
                                      : item.status == "disabled"
                                      ? "Disabled"
                                      : "Blocked"}
                                  </Button>
                                </td>
                                <td>
                                  <Row>
                                    <div className="d-flex justify-content-around">
                                      <div
                                        style={{
                                          width: 30,
                                          textAlign: "center",
                                        }}
                                        className="text-primary"
                                      >
                                        <a
                                          className="font-size-18"
                                          onClick={() => {
                                            props?.history?.push("/edit-user", {
                                              edit: true,
                                              item: item,
                                            });
                                          }}
                                        ><FaPen /></a>
                                      </div>

                                      <div style={{ width: 30 }}>
                                        {item.role_name != "merchant" ? (
                                          <Link
                                            to="#"
                                            className="px-3 text-danger"
                                          >
                                            <i
                                              className="font-size-18"
                                              onClick={() => {
                                                setItemForDelete(item);
                                                setDelete(true);
                                              }}
                                            ><FaRegTrashAlt /></i>
                                          </Link>
                                        ) : (
                                          <Link
                                            to="#"
                                            className="px-3 text-danger"
                                          >
                                            <i className="font-size-16"><FaBan /></i>
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  </Row>
                                </td>
                              </tr>
                            );
                          })}
                      {showsScrolBtn && <div
                        id="scrolToTop"
                          onClick={() => {
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                          }}
                          style={{
                            position: "fixed",
                            bottom: "60px", 
                            right: "60px",
                            color: "gray",
                            textAlign: "center",
                            cursor: "pointer",
                            fontSize: "4em",
                            lineHeight: 0,
                            textDecoration:"none",
                          }}
                        >
                          <img src={ScrollImage} alt="" 
                          style={{width: "40px",
                            background: "#34C38F",
                            borderRadius: "50%",
                            padding:"5px"}} />
                        </div>}
                      </tbody>
                    </table>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserManagement;
